/**
 * Name of the cookie that stores a JSON object containing the attributes for the active checkout in name: value pairs.
 * This cookie is set on the Shopify checkout by src/scripts/layout/checkout.js in the Shopify Theme.
 * @type {string}
 */
export const SHOPIFY_CHECKOUT_ATTRIBUTES_COOKIE = 'bt-co-attr';
